<template>
    <div class="old-browser">


    <header>
        <div class="container"  v-click-outside="closeMenu">
            <div class="row justify-content-between">
                <div class="col-md-2 col-8">
                    <div class="logo">
                            <img src="/img/header/logo.svg" alt="">
                    </div>
                </div>

                <div class="col-lg-9 align-items-center d-none d-lg-flex justify-content-center">
                    <div class="head__items">
                        <div class="head-item">
                            <div class="img">
                                <img src="/img/header/shield.svg" alt="">
                            </div>
                            <div class="info">
                                <p class="min-min p-dgrey">Elbyte med prisgaranti</p>
                            </div>
                        </div>
                        <div class="head-item">
                            <div class="img">
                                <img src="/img/header/scales.svg" alt="">
                            </div>
                            <div class="info">
                                <p class="min-min p-dgrey">Jämför och byt gratis </p>
                            </div>
                        </div>
                        <div class="head-item">
                            <div class="img">
                                <img src="/img/header/calendar.svg" alt="">
                            </div>
                            <div class="info">
                                <p class="min-min p-dgrey">14 dagars ångerrätt</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </header>
        <div class="main" style="margin: 50px auto 50px auto; text-align: center; max-width: 500px">
            <div style=" ">
                <h1>You are using an Outdated Browser. For a use this website, please upgrade your web browser </h1>
            </div>
        </div>
        <footer>
            <div class="container">
                <div class="row">
                    <div class="col-md-3">
                        <div class="foot-logo">
                            <img src="/img/logo-footer.svg" alt="">
                        </div>

                        <p class="Raleway min p-white">Made with <img src="/img/icon/like.svg" alt=""> in Sweden</p>
                    </div>
                    <div class="col-md-1">

                    </div>
                    <div class="col-md-5">
                        <div class="foot-nav">
                            <div class="row">
                                <div class="col-md-5">
                                </div>
                                <div class="col-md-7">

                                    <p class="Raleway min p-white swed-links"><img src="/img/icon/sweden.svg" alt="">
                                        <router-link  :to="{name: 'index'}">
                                            Show site in Swedish
                                        </router-link>

                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-1">

                    </div>
                    <div class="col-md-2">
                        <p class="min-min foot-info p-white">Allmän information</p>
                        <p class="min foot-info p-white">TecknaEl.se </p>
                        <p class="min foot-info p-white">Orgno: 444344-1235</p>
                    </div>
                </div>
            </div>

        </footer>
    </div>
</template>

<script>
    export default {
        name: "OldBrowserPageWarn"
    }
</script>
